import { render, staticRenderFns } from "./WaterNetworkDevelopmentSettings.vue?vue&type=template&id=176707a6&"
import script from "./WaterNetworkDevelopmentSettings.vue?vue&type=script&lang=js&"
export * from "./WaterNetworkDevelopmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports